import {ATTRIBUTE_EVENT_CODE, ATTRIBUTE_EVENT_DATE, ATTRIBUTE_EVENT_SOURCE} from 'src/modules/event-create/constants';
import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

export const eventCodeInfoToEventChangeRequest = (eventCodeInfo: EventDetailInfo): EventChangeRequest => {
    const attributes = [...eventCodeInfo.attributes];
    const sortedAttributes = attributes.sort((a, b) => a.name.localeCompare(b.name));
    const mappedAttributes = sortedAttributes.map(attribute => {
        if (attribute.name === ATTRIBUTE_EVENT_CODE) {
            return {
                ...attribute,
                possibleValues: !attribute.possibleValues.includes(attribute.eventCode) ?
                        [attribute.eventCode] : attribute.possibleValues,
                required: true,
            };
        }
        if (attribute.name === ATTRIBUTE_EVENT_SOURCE) {
            return {
                ...attribute,
                possibleValues: !attribute.possibleValues.includes(attribute.source) ?
                        [attribute.source] : attribute.possibleValues,
                required: true};
        }
        if (attribute.name === ATTRIBUTE_EVENT_DATE) {
            return {...attribute, required: true};
        }
        return attribute;
    });

    return {
        ...eventCodeInfo,
        source: eventCodeInfo.source,
        trigger: eventCodeInfo.trigger || '',
        attributes: mappedAttributes as AttributeChangeRequest[],
    };
};
